import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core';
import LibrarySectionList from '../LibrarySectionList'
import FeedGroup from './DataGroup'
import { dtoForMembers, isNeedDTOForMembers } from '../../../../../utils/membersDTO';
import { joinToPublicGroup } from '../../../groups/groupUtils';
import { librarySections } from '../../../../../utils/library/librarySections';
import NoItemsPlaceholder from '../NoItemsPlaceholder/NoItemsPlaceholder';

const HEIGHT_NO_ITEMS = 150
const HEIGHT_CONTAINER = 330

const styles = theme => ({
    dataGroupsContainer: {
        height: HEIGHT_CONTAINER,
        width: 1286,
        backgroundColor: '#f5f5f5',
        marginTop: 48,
        marginRight: 'auto',
        marginLeft: 'auto',
    },
    headerSection: {
        height: 70,
        display: 'flex',
        flexDirection: 'row',
    },
    titles: {
        flexDirection: 'column',
        marginRight: 'auto'
    },
    title: {
        fontFamily: 'Rubik',
        fontSize: 32,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#21212d',
    },
    subtitle: {
        fontFamily: 'Rubik',
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.75,
        letterSpacing: 'normal',
        color: '#a3a3a3',
    },
    controlButtons: {
        flexDirection: 'column',
        alignSelf: 'center',
        border: 'solid 2px #e0e0e0',
        borderRadius: 4,
        width: 84,
        height: 38,
    },
    dataGroups: {
        marginTop: (46 + 14) * -1,
        display: 'grid',
        gridTemplateColumns: 'auto auto auto',
        justifyContent: 'flex-start',
    },
    disableIcon:{
        fill: theme.newUI.color.gray
    },
    activeIcon:{
        cursor: 'pointer',
        fill: theme.newUI.color.commonBlack
    },
    leftButton: {
        width: 42,
        height: 38,
        background: 'none',
        border: 'none',
    },
    rightButton: {
        width: 42,
        height: 38,
        borderRadius: 4,
        background: 'none',
        border: 'none',
        borderLeft: 'solid 0.5px #e0e0e0',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    buttonAll: {
        flexDirection: 'column',
        marginRight: 12,
        marginLeft: 'auto',
    },
    controlWrap: {
        width: 1286,
        top: 0,
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    listContainer: {
        width: 1286,
        height: 330,
        alignItems: 'end'
    },
    cardsContainer: {
        position: 'absolute',
        top: 60,
    },
});

const mapDataGroups = (dataCollections, allUsers) => dataCollections.map(collection => {
    const {collectionGroup} = collection
    const needsDTO = isNeedDTOForMembers(collectionGroup.groupUsers)
    return {
        title: collectionGroup.title || collection.title || '',
        subtitle:  collectionGroup.description || collection.description || '',
        followers: needsDTO ? dtoForMembers(collectionGroup.groupUsers, allUsers) : collectionGroup.groupUsers,
        backgroundImage: collection.backgroundUrl || '',
        collectionUid: collection.collectionUid,
        groupUid: collection.collectionGroup.groupUid,
        meta: collection
    }
})
const SCREEN_ITEMS = 3 

const DataGroups = (props) => {
    const {classes, users, dataCollections} = props

    const [dataGroups, setDataGroups] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setDataGroups(mapDataGroups(dataCollections, users))
    }, [dataCollections])

    const Header = (
        <div data-intrcm-id="DataGroups_oerv2dc4" className={classes.title}>{librarySections().dataGroups.title}</div>
    )
    const SubHeader = (
        <div data-intrcm-id="DataGroups_yk451118" className={classes.subtitle}>{librarySections().dataGroups.subtitle}</div>
    )

    const join = (groupUid, goToCollection) => {
        if(isLoading) return
        const { searchQuery, dispatch, queryService, groupService, userSettingsService } = props;
        setIsLoading(true)
        joinToPublicGroup(groupUid, searchQuery, dispatch, queryService, groupService, userSettingsService, () => {
            dispatch({ type: 'DATA_UPDATE' });
            setIsLoading(false);
            goToCollection()
        })
    }

    const controlStyles = {
        controlWrap: classes.controlWrap,
        controlButtons: classes.controlButtons,
        leftButton: classes.leftButton,
        rightButton: classes.rightButton,
        activeIcon: classes.activeIcon,
        disableIcon: classes.disableIcon,
        arrowBg: 'transparent'
    }

        return (
            <div data-intrcm-id="DataGroups_kuhoknvf" style={{height: dataGroups.length === 0 ? HEIGHT_NO_ITEMS : HEIGHT_CONTAINER}} className={classes.dataGroupsContainer}>
              <div data-intrcm-id="DataGroups_77qgxdg1" className={classes.headerSection} >
                <div data-intrcm-id="DataGroups_2q37bivt" className={classes.titles}>
                    {Header}
                    {SubHeader}
                </div>
              </div>
              {dataGroups.length === 0 &&
                <NoItemsPlaceholder placeholder={"No data groups available"} />
              }
              <div data-intrcm-id="DataGroups_7evuj1kl" className={classes.dataGroups}>
              {dataGroups.length > 0 &&
                <LibrarySectionList screenSize={SCREEN_ITEMS} listContainerStyle={classes.listContainer} cardsContainerStyle={classes.cardsContainer} controlStyles={controlStyles} >
                    {dataGroups.map((dataGroup, i) => (
                        <FeedGroup key={i} dataGroup={dataGroup} join={join} />
                    ))}
                </LibrarySectionList>
              }
              </div>
            </div>
        )
}

const mapStateToProps = (state) => ({
    users: state.globalData.users,
    profileData: state.userData.profileData,
    groupService: state.services.groupService,
    userSettingsService: state.services.userSettingsService,
    queryService: state.services.queryService,
    searchQuery: state.search
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps))(DataGroups);